// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"products-table-row-view-nophoto_shadow__vCNGJ","noPhoto":"products-table-row-view-nophoto_noPhoto__1J83G"};